import { fromJS, List, Map } from 'immutable'
import _ from 'lodash'
import { getElementDataRoot } from '../constants/getElementDataRoot'

export const updateState = (state, path, value) =>
  state.setIn(['state'], fromJS(_.set(state.getIn(['state'], new Map()).toJS(), path, value)))

export const detectIsTargetKeyInRepeatEl = (path, retState) => {
  let [pageUID, stripUID, ...rest] = path
  if (String(stripUID).indexOf('##') !== -1) {
    stripUID = _.first(String(stripUID).split('##'))
  }
  const isPageElem = retState.hasIn(['project', 'Settings', 'elements', stripUID]) ? 'project' : retState.get('page')
  const elPath = getElementDataRoot(isPageElem)
  const isRepeatedStrip =
    retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).findIndex((v) => v === stripUID) !== -1
  if (path[1] === path[2] && !isRepeatedStrip) {
    return false
  }
  const el = retState.getIn([...elPath, 'elements', stripUID], new Map())
  const elType = el.get('type')
  if (
    elType === 'InteractiveImage' ||
    elType === 'PowerTable' ||
    elType === 'RepeatAutoFit' ||
    (elType === 'Strip' &&
      (isRepeatedStrip || el.getIn(['props', 'isRepeat'], false) || el.getIn(['props', 'isRepeatCol'], false)))
  ) {
    return true
  } else {
    return false
  }
}

export const setValueForElementType = (retState, statePath, additionalPath, value) => {
  return updateState(retState, [...statePath, ...additionalPath], value)
}
